// login-modal-controller.js
let showLoginModalCallback = null;

export const setShowLoginModalCallback = (callback) => {
  showLoginModalCallback = callback;
};

export const showLoginModal = () => {
  if (showLoginModalCallback) {
    showLoginModalCallback();
  }
};
